import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const VisitingCard = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path
        d="M16.69 5.6C18.73 5.6 20.4 7.26 20.4 9.31V14.57C20.4 16.61 18.74 18.28 16.69 18.28H7.31C5.27 18.28 3.6 16.62 3.6 14.57V9.31C3.6 7.27 5.26 5.6 7.31 5.6H16.69ZM16.69 4H7.31C4.38 4 2 6.38 2 9.31V14.57C2 17.5 4.38 19.88 7.31 19.88H16.69C19.62 19.88 22 17.5 22 14.57V9.31C22 6.38 19.62 4 16.69 4Z"
        fill={color}
      />
      <Path
        d="M7.6702 11.4498C8.48205 11.4498 9.1402 10.7916 9.1402 9.97976C9.1402 9.16791 8.48205 8.50977 7.6702 8.50977C6.85834 8.50977 6.2002 9.16791 6.2002 9.97976C6.2002 10.7916 6.85834 11.4498 7.6702 11.4498Z"
        fill={color}
      />
      <Path
        d="M8.57043 11.8499H7.01043C5.73043 11.8499 4.69043 12.8999 4.69043 14.1699V14.9199C4.69043 15.1699 4.89043 15.3699 5.14043 15.3699H10.4404C10.6904 15.3699 10.8904 15.1699 10.8904 14.9199V14.1699C10.8904 12.8899 9.84043 11.8499 8.57043 11.8499Z"
        fill={color}
      />
      <Path
        d="M18.5202 9.58984H12.9602C12.5202 9.58984 12.1602 9.94984 12.1602 10.3898C12.1602 10.8298 12.5202 11.1898 12.9602 11.1898H18.5202C18.9602 11.1898 19.3202 10.8298 19.3202 10.3898C19.3202 9.94984 18.9602 9.58984 18.5202 9.58984Z"
        fill={color}
      />
      <Path
        d="M16.2904 12.6897H12.9104C12.4704 12.6897 12.1104 13.0497 12.1104 13.4897C12.1104 13.9297 12.4704 14.2897 12.9104 14.2897H16.2904C16.7304 14.2897 17.0904 13.9297 17.0904 13.4897C17.0904 13.0497 16.7304 12.6897 16.2904 12.6897Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default VisitingCard
